import ActionType from 'actions/ActionType'

export default (state = true, action) => {
	switch (action.type) {
		case ActionType.CustomForm.TOGGLE_CUSTOM_LANDING_PAGE:
			if (typeof action.payload === 'boolean') {
				return action.payload
			}
			return !state
		case ActionType.CustomForm.RECEIVE_FORM:
			if (action?.payload) {
				if (action?.payload?.landing_page?.url) {
					return false
				}
				if (action?.payload?.landing_page?.content) {
					return true
				}
			}
			return true
		default:
			return state
	}
}
